import type { Location } from 'react-router-dom';

const DEFAULT_RETURN_PATH = '/documents';

export function getReturnPath(from?: Pick<Location, 'pathname' | 'search' | 'hash'> | null): string {
  if (!from?.pathname) return DEFAULT_RETURN_PATH;
  return `${from.pathname}${from.search ?? ''}${from.hash ?? ''}`;
}

/** Only allow same-origin relative paths (prevents open redirects). */
export function isSafeReturnPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//');
}

export function resolveReturnPath(location: Location, searchParams: URLSearchParams): string {
  const fromState = (location.state as { from?: Location } | null)?.from;
  if (fromState) {
    const path = getReturnPath(fromState);
    if (isSafeReturnPath(path)) return path;
  }

  const returnTo = searchParams.get('returnTo');
  if (returnTo && isSafeReturnPath(returnTo)) {
    return returnTo;
  }

  return DEFAULT_RETURN_PATH;
}

export function buildLoginUrlWithReturn(returnPath: string): string {
  return `/login?returnTo=${encodeURIComponent(returnPath)}`;
}
